/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from 'axios';
import Core from '../core';
import { store } from '../../infra/store';

async function postAnswers(payload: any) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.post(`/api/answers`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function postEvaluation(id: string, payload: any) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.post(`/api/questionnaires/${id}/submit`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getEvaluationSheetById(id: string) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(`/api/evaluation-sheets/${id}`);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function deleteEvaluationSheetById(id: number) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.delete(`/api/evaluation-sheets/${id}`);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getEvaluations() {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(`/api/evaluations/kpis`);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getAssignedEvaluation() {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(`/api/evaluations/assigned`);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getEvaluatorById(id: string) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(`/api/evaluations/${id}/evaluator-users`);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getEmployeeDetail(employeeId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(`/getEmpDetail?empId=${employeeId}`);
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getMyTeamData(
  employeeId: number,
  current_user_id: number,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-team?&current_employee_id=${employeeId}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function getMyTeamDataBySearch(
  current_employee_id: number,
  current_user_id: number,
  search: string,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-team?search=${search}&current_employee_id=${current_employee_id}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function getMyTeamDataByFilter(
  employeeId: number,
  current_user_id: number,
  status: string,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-team?&status=${status}&current_employee_id=${employeeId}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function getMyTeamDataBySearchAndFilter(
  current_employee_id: number,
  current_user_id: number,
  status: string,
  search: string,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-team?search=${search}&status=${status}&current_employee_id=${current_employee_id}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getMyPerformanceData(
  current_employee_id: number,
  current_user_id: number,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-performance?&current_employee_id=${current_employee_id}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getMyPerformanceDataBySearch(
  current_employee_id: number,
  current_user_id: number,
  search: string,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-performance?search=${search}&current_employee_id=${current_employee_id}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );
  // if (data instanceof AxiosError) {
  //   return data.response;
  // }
  const response = data.data;
  return response;
}
async function getMyPerformanceDataByStatusCount(
  current_employee_id: number,
  current_user_id: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-performance-status-count?current_employee_id=${current_employee_id}&current_user_id=${current_user_id}`,
  );
  const response = data.data;
  return response;
}

async function getMyTeamDataByStatusCount(
  current_employee_id: number,
  current_user_id: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-team-status-count?current_employee_id=${current_employee_id}&current_user_id=${current_user_id}`,
  );
  const response = data.data;
  return response;
}
async function getMyPerformanceDataByFilter(
  current_employee_id: number,
  current_user_id: number,
  status: string,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-performance?&status=${status}&current_employee_id=${current_employee_id}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getMyPerformanceDataBySearchAndFilter(
  current_employee_id: number,
  current_user_id: number,
  status: string,
  search: string,
  skip: number,
  limit: number,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `/api/evaluation-sheets/my-performance?search=${search}&status=${status}&current_employee_id=${current_employee_id}&current_user_id=${current_user_id}&skip=${skip}&limit=${limit}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getMyTeamEmployees(user_id: number, employeeId: number) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(
    `api/employees/${user_id}/teams?employeeId=${employeeId}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getEvaluationSheetByEvaluatorId(
  evaluationId: string,
  questionnaireId: string,
  currentUserId: number,
  id: string,
) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  try {
    const data = await api.get(
      `api/evaluators/${id}/evaluation-sheet?evaluationId=${evaluationId}&questionnaireId=${questionnaireId}&currentUserId=${currentUserId}`,
    );
    return data?.data;
  } catch (error: any) {
    return error?.response || error?.error;
  }
}

async function getKpis(kpi_id: string) {
  const myStore: any = store.getState();
  const companyID: any = myStore.authSlice?.company_id;
  const api = Core.getInstance().pmsapi(companyID);
  const data = await api.get(`api/kpis/${kpi_id}`);
  if (data instanceof AxiosError) {
    return data?.response;
  }
  const response = data?.data;
  return response;
}

export const performanceService = {
  getEmployeeDetail,
  postAnswers,
  postEvaluation,
  getEvaluationSheetById,
  getEvaluatorById,
  getMyTeamData,
  getMyTeamDataBySearch,
  getMyTeamDataByFilter,
  getMyTeamDataBySearchAndFilter,
  getMyPerformanceData,
  getMyPerformanceDataBySearch,
  getMyPerformanceDataByFilter,
  getMyPerformanceDataBySearchAndFilter,
  deleteEvaluationSheetById,
  getEvaluations,
  getAssignedEvaluation,
  getMyTeamEmployees,
  getEvaluationSheetByEvaluatorId,
  getKpis,
  getMyTeamDataByStatusCount,
  getMyPerformanceDataByStatusCount,
};
